














































import Vue from 'vue';
import Component from 'vue-class-component';
import { IModal } from '@/interfaces/interfaces';

import LoginForm from '@/components/Form/Login.form.vue';
import LoginDBPForm from '@/components/Form/LoginDBP.form.vue';
import ResetPasswordForm from '@/components/Form/ResetPassword.form.vue';
import ResetPasswordSuccess from '@/components/Form/ResetPassword.success.form.vue';
import RegisterForm from '@/components/Form/Register.form.vue';
import RegisterDBPForm from '@/components/Form/RegisterDBP.form.vue';
import RegisterLicense from '@/components/Form/Register.license.vue';
import RegisterSuccess from '@/components/Form/Register.success.vue';
import ProfileForm from '@/components/Form/Profile.form.vue';
import Iframe from '@/components/UI/Iframe.vue';
import SchoolNotFoundError from '@/components/Layout/Header/SchoolNotFoundError.vue';
import SeveralUsersLinkedToDepartmentError from '@/components/Layout/Header/SeveralUsersLinkedToDepartmentError.vue';
import LoginDisabledError from '@/components/Layout/Header/LoginDisabledError.vue';
import ChangeEmailForm from '@/components/Form/ChangeEmail.form.vue';

import {createHelpers} from 'vuex-map-fields';
const { mapFields } = createHelpers({
  getterType: 'getUiField',
  mutationType: 'updateUiField',
});

@Component({
  components: {
    LoginForm,
    LoginDBPForm,
    ResetPasswordForm,
    ResetPasswordSuccess,
    RegisterForm,
    RegisterDBPForm,
    RegisterLicense,
    RegisterSuccess,
    Iframe
  },
  computed: {...mapFields([
      'modalState'
    ]),
  }
})

export default class HeaderModals extends Vue {
  public url: string = '';
  public modalComponentProps: Record<string, any> = {};

  public openHandler = (event: Event) => {
    this.openModal((event as CustomEvent).detail.id);
    this.$set(this.modalComponentProps, 'params', (event as CustomEvent).detail.params);
  }
  public closeHandler = () => {
    this.closeModal();
    this.$set(this.modalComponentProps, 'params', {});
  }

  public mounted() {
    this.$root.$on('openHeaderModal', (id: string) => this.openModal(id));
    this.$root.$on('closeHeaderModal', () => this.closeModal());

    window.addEventListener('openHeaderModal', this.openHandler);
    window.addEventListener('closeHeaderModal', this.closeHandler);
  }

  private modals: IModal[] = [
    {
      id: 'login',
      title: 'Anmelden',
      maxWidth: '560px',
      component: LoginForm
    },
    {
      id: 'login-dbp',
      title: 'Kontenverknüpfung',
      maxWidth: '560px',
      disableCancel: true,
      component: LoginDBPForm
    },
    {
      id: 'resetPassword',
      title: 'Passwort zurücksetzen',
      maxWidth: '560px',
      component: ResetPasswordForm
    },
    {
      id: 'changePassword',
      title: 'Passwort ändern',
      maxWidth: '560px',
      component: ResetPasswordForm,
      type: 'change'
    },
    {
      id: 'changeEmail',
      title: 'E-Mail ändern',
      maxWidth: '560px',
      component: ChangeEmailForm
    },
    {
      id: 'resetPasswordSuccess',
      title: 'Passwort vergessen',
      maxWidth: '560px',
      component: ResetPasswordSuccess
    },
    {
      id: 'changePasswordSuccess',
      title: 'Passwort ändern',
      maxWidth: '560px',
      component: ResetPasswordSuccess
    },
    {
      id: 'register',
      title: 'Zugang anfordern',
      maxWidth: '560px',
      component: RegisterForm
    },
    {
      id: 'register-dbp',
      title: 'Zugang anfordern',
      maxWidth: '560px',
      disableCancel: true,
      component: RegisterDBPForm
    },
    {
      id: 'registerLicense',
      title: 'Einwilligungserklärung',
      maxWidth: '955px',
      component: RegisterLicense
    },
    {
      id: 'register-license-dbp',
      title: 'Einwilligungserklärung',
      maxWidth: '955px',
      disableCancel: true,
      component: RegisterLicense
    },
    {
      id: 'registerSuccess',
      title: 'Registrierung erfolgreich',
      maxWidth: '560px',
      component: RegisterSuccess
    },
    {
      id: 'profile',
      title: 'Benutzerdaten',
      maxWidth: '560px',
      component: ProfileForm
    },
    {
      id: 'rentalFrame',
      title: 'Verleihkonto',
      maxWidth: '1200px',
      component: Iframe,
      height: '50vh'
    },
    {
      id: 'school-not-found-login',
      title: 'Fehler',
      maxWidth: '560px',
      disableCancel: true,
      component: SchoolNotFoundError
    },
    {
      id: 'school-not-found-registration',
      title: 'Fehler',
      maxWidth: '560px',
      disableCancel: true,
      component: SchoolNotFoundError
    },
    {
      id: 'school-not-found-error',
      title: 'Fehler',
      maxWidth: '560px',
      component: SchoolNotFoundError
    },
    {
      id: 'several-users-linked-to-department-error',
      title: 'Fehler',
      maxWidth: '560px',
      component: SeveralUsersLinkedToDepartmentError
    },
    {
      id: 'login-disabled-error',
      title: 'Fehler',
      maxWidth: '560px',
      component: LoginDisabledError
    }
  ];

  private visibleData: boolean[] = [];

  private setDefaultVisibleData() {
    this.visibleData = [...Array(this.modals.length).fill(false)];
  }

  private getIndexById(id: string): number {
    return this.modals
      .findIndex((modal: IModal) => modal.id === id);
  }

  public openModal(id: string, url?: string): void {
    url ? this.url = url : this.url = '';
    this.setDefaultVisibleData();
    this.visibleData
      .splice(this.getIndexById(id), 1, true);
  }

  public closeModal(): void {
    this.$store.commit('RESET_MODALS');
    this.setDefaultVisibleData();
  }
}
